import { firstValueFrom } from 'rxjs';
import { DriverResponse } from 'src/app/models/driver.model';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { SqliteStorageService } from 'src/app/services/sqlite-storage/sqlite-storage.service';
import { UserProvider } from 'src/app/services/providers/user-provider.ts/user-provider';

export interface DriverDataDependencies {
  dashboardService: DashboardService;
  sqliteStorageService: SqliteStorageService;
  userProvider: UserProvider;
}

// Shared memory -> cache -> network lookup so guards agree on the same driver/vehicle data 
export async function resolveDriverData(deps: DriverDataDependencies): Promise<DriverResponse | null> {
  const { dashboardService, sqliteStorageService, userProvider } = deps;
  let driverData: DriverResponse | null = userProvider.readDriverData();

  if (!driverData) {
    driverData = await sqliteStorageService.getItem<DriverResponse>('meData');
    if (driverData) {
      userProvider.setDriverData(driverData);
    }
  }

  if (!driverData && typeof navigator !== 'undefined' && navigator.onLine) {
      driverData = await firstValueFrom(dashboardService.getMeDataForGuard());
      userProvider.setDriverData(driverData);
      await sqliteStorageService.setItem('meData', driverData);
  }

  return driverData;
}